module.exports = __webpack_public_path__ + "static/media/terumi_wakiyama_600x600.23ff5dc6.jpg";